/**
 * This file contains logic that is specific to default currency experiment, including
 * US: https://pxpdev.paypal.com/configuration?exptId=3248
 * Rest of the world: https://pxpdev.paypal.com/configuration?exptId=3294
 * As we've decided to go with 100% T4 experience, removed all the pxp check in this file.
 */

/**
 * This function map the keys we get from service to keys
 */
export function mapDefaultCurrencyKeys(obj = {}) {
  const keyMap = {
    recipientLocalCurrency: 'rcur',
    senderCountryCode: 'sndcc',
    senderLocalCurrency: 'sndcur',
  }

  return Object.keys(obj).reduce((acc, curr) => {
    acc[keyMap[curr]] = obj[curr]
    return acc
  }, {})
}

/**
 * Reorder the currency list: put receiver's local currency at the first of the list
 *
 */
export function reorderCurrencyList(targetCurrency, currencyList) {
  const currencyItem = currencyList.find(item => item.code === targetCurrency)
  if (!currencyItem) {
    return currencyList
  }

  return [
    currencyItem,
    ...currencyList.filter(currency => currency.code !== currencyItem.code),
  ]
}
